import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api } from '../lib/api';

const ContentContext = createContext(null);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    let mounted = true;
    api.listContent()
      .then(r => { if (mounted) setContent(r.data || {}); })
      .catch(() => { /* silent */ })
      .finally(() => { if (mounted) setLoaded(true); });
    return () => { mounted = false; };
  }, []);

  const getContent = useCallback((key, fallback = '') => {
    const v = content[key];
    if (v === undefined || v === null || v === '') return fallback;
    return v;
  }, [content]);

  const saveContent = useCallback(async (key, value) => {
    await api.updateContent(key, value);
    setContent(c => ({ ...c, [key]: value }));
  }, []);

  return (
    <ContentContext.Provider value={{ getContent, saveContent, loaded }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => {
  const ctx = useContext(ContentContext);
  if (!ctx) throw new Error('useContent must be used inside ContentProvider');
  return ctx;
};
